import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ userType, isOpen = false, onClose = () => {} }) => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);


  useEffect(() => {
  // activeLink に一致する a 要素を探してフォーカス
  const selector = `a[href='${activeLink}']`;
  const el = document.querySelector(selector);
  if (isOpen && el) el.focus();
}, [isOpen, activeLink]);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const L = ({ to, children }) => (
    <li>
      <Link to={to} className={activeLink === to ? 'active' : ''} onClick={onClose}>
        {children}
      </Link>
    </li>
  );

  const Section = ({ title, children }) => (
    <>
      <div className="sectionTitle">{title}</div>
      <ul>{children}</ul>
      <hr />
    </>
  );

  const MenuAdmin = () => (
    <>
     <Section>
     </Section>

      <Section title="会員メニュー">
        <L to="/enduser/usersettings">アカウント設定</L>
        <L to="/enduser/entrydogs">出陳犬登録</L>
        <L to="/enduser/eventlist">イベント一覧</L>
        <L to="/enduser/entryhistory">エントリー履歴</L>
      </Section>
      
      {/* <Section title="管理メニュー">
        <L to="/operator/operatorevent">イベント管理</L>
      </Section> */}

      <Section title="管理メニュー">
        <L to="/admin/eventmanagement">イベント管理</L>
        <L to="/admin/usermanagement">ユーザー管理</L>
        <L to="/admin/dogmanagement">犬種管理</L>
        <L to="/admin/systemsetting">システム設定</L>
      </Section>

      {/* <Section title="参加メニュー">
        <L to="/guest/dashboard">招待一覧</L>
      </Section> */}
    </>
  );

  const MenuOperator = () => (
    <>
     <Section>
     </Section>

      <Section title="会員メニュー">
        <L to="/enduser/usersettings">アカウント設定</L>
        <L to="/enduser/entrydogs">出陳犬登録</L>
        <L to="/enduser/eventlist">イベント一覧</L>
        <L to="/enduser/entryhistory">エントリー履歴</L>
      </Section>
     
      <Section title="管理メニュー">
        <L to="/operator/operatorevent">イベント管理</L>
      </Section>

      {/* <Section title="参加メニュー">
        <L to="/guest/dashboard">招待一覧</L>
      </Section> */}
    </>
  );


  const MenuEnduser = () => (
    <>
      <Section>
     </Section>
     
      <Section title="会員メニュー">
        <L to="/enduser/usersettings">アカウント設定</L>
        <L to="/enduser/entrydogs">出陳犬登録</L>
        <L to="/enduser/eventlist">イベント一覧</L>
        <L to="/enduser/entryhistory">エントリー履歴</L>
      </Section>

      {/* <Section title="参加メニュー">
        <L to="/guest/dashboard">招待一覧</L>
      </Section> */}
    </>
  );


  const MenuSystem = () => (
    <>
      <Section>
     </Section>

      <Section title="会員メニュー">
        <L to="/enduser/usersettings">アカウント設定</L>
        <L to="/enduser/entrydogs">出陳犬登録</L>
        <L to="/enduser/eventlist">イベント一覧</L>
        <L to="/enduser/entryhistory">エントリー履歴</L>
      </Section>
     
      <Section title="管理メニュー">
        <L to="/operator/operatorevent">イベント管理</L>
      </Section>

      <Section title="管理メニュー">
        <L to="/admin/eventmanagement">イベント管理</L>
        <L to="/admin/usermanagement">ユーザー管理</L>
        <L to="/admin/dogmanagement">犬種管理</L>
      </Section>

      <Section>
        <L to="/system/settings">設定</L>
      </Section>
    </>
  );


  return (
    <div className="sidebar-container">
      <nav className={`sidebar ${isOpen ? 'open' : ''}`}>
        {userType === 'system' ? <MenuSystem /> : userType === 'admin' ? <MenuAdmin /> : userType === 'operator' ? <MenuOperator /> : userType === 'enduser' ? <MenuEnduser /> : <MenuGuest />}
      </nav>
      <div className={`sidebar-backdrop ${isOpen ? 'show' : ''}`} onClick={onClose} />
    </div>
  );
};

export default Sidebar;
